import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getClientConfig } from '../../config/clientConfig';
import HELPERS from '../../utils/helper';
import { Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import './template9.css';

// Coaching Center Template - Compact & Action-Oriented Design
class EnquiryTemplate9 extends Component {
  constructor(props) {
    super(props);
    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        area: '',
        course: '',
        message: ''
      },
      errors: {},
      disabled: false,
      areas: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses,
    };
  }

  componentDidMount() {
    if (this.state.clientConfig) {
      this.fetchAreas();
      this.fetchCourses();
    }
  }

  fetchAreas = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };
      const areasUrl = apis.getAreasUrl(clientConfig);
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);
      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push(areaObj.area);
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.useFallbackAreas();
        }
      }
    } catch (err) {
      this.useFallbackAreas();
    }
  }

  useFallbackAreas = () => {
    this.setState({
      areas: ['Vesu', 'Adajan', 'Varachha', 'Piplod', 'City Light', 'Athwa', 'Rander', 'Althan']
    });
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Timezone': 'Asia/Calcutta'
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }));
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      errors.phone = 'Enter valid 10-digit phone';
    }

    if (formData.email.trim() && !HELPERS.validateEmail(formData.email)) {
      errors.email = 'Enter valid email';
    }

    if (!formData.course.trim()) {
      errors.course = 'Please select a course';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({ loader: true, disabled: true });

    try {
      const { clientConfig, formData } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const payload = {
        name: formData.name,
        mobile: formData.phone,
        email: formData.email || '',
        comments: formData.message || 'No additional message',
        institute_id: clientConfig.instituteId,
        customComponentList: [],
        mCourseName: formData.course || '',
        state: clientConfig.api.defaults.state,
        city: clientConfig.api.defaults.city,
        area: formData.area || clientConfig.api.defaults.defaultArea
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 || res.status === 201) {
        Toast('Enquiry submitted! We will contact you soon.', toastMsgConfig('s'));
        this.setState({
          formData: {
            name: '',
            phone: '',
            email: '',
            area: '',
            course: '',
            message: ''
          },
          loader: false,
          disabled: false
        });
      } else {
        Toast('Something went wrong. Please try again.', toastMsgConfig('e'));
        this.setState({ loader: false, disabled: false });
      }
    } catch (error) {
      Toast('Failed to submit. Please try again.', toastMsgConfig('e'));
      this.setState({ loader: false, disabled: false });
    }
  }

  render() {
    const { formData, errors, disabled, loader, areas, courses, clientConfig } = this.state;

    if (!clientConfig) {
      return null;
    }

    return (
      <div className="template9-container">
        {/* Floating Header Bar */}
        <div className="template9-header">
          <div className="template9-header-content">
            <div className="template9-branding">
              <img src={clientConfig.branding.logo} alt={clientConfig.clientName} />
              <div className="template9-brand-text">
                <h1>{clientConfig.clientName}</h1>
                <p>{clientConfig.branding.heroSubtitle}</p>
              </div>
            </div>
            <div className="template9-quick-contact">
              <a href={`tel:${clientConfig.contactInfo.phone1}`} className="template9-call-btn">
                <i className="fa fa-phone"></i> {clientConfig.contactInfo.phone1}
              </a>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="template9-main">
          {/* Left Side - Benefits */}
          <div className="template9-benefits">
            <div className="template9-badge">
              <i className="fa fa-award"></i>
              <span>{clientConfig.branding.badgeText}</span>
            </div>

            <h2 className="template9-headline">Start Your Journey to Success</h2>

            {/* Stats Boxes */}
            <div className="template9-stats">
              <div className="template9-stat-box">
                <i className="fa fa-users"></i>
                <div>
                  <strong>{clientConfig.stats.alumni}</strong>
                  <span>Students</span>
                </div>
              </div>
              <div className="template9-stat-box">
                <i className="fa fa-graduation-cap"></i>
                <div>
                  <strong>{clientConfig.stats.placement}</strong>
                  <span>Success Rate</span>
                </div>
              </div>
              <div className="template9-stat-box">
                <i className="fa fa-trophy"></i>
                <div>
                  <strong>{clientConfig.stats.experience} Years</strong>
                  <span>Experience</span>
                </div>
              </div>
            </div>

            {/* Features List */}
            <div className="template9-features">
              <h3>Why Choose Us?</h3>
              <ul>
                {clientConfig.features.map((feature, index) => (
                  <li key={index}>
                    <i className="fa fa-check"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="template9-contact">
              <div className="template9-contact-item">
                <i className="fa fa-envelope"></i>
                {clientConfig.contactInfo.email}
              </div>
              <div className="template9-contact-item">
                <i className="fa fa-map-marker"></i>
                {clientConfig.contactInfo.address}
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="template9-form-section">
            <div className="template9-form-card">
              <div className="template9-form-header">
                <h2>Quick Enquiry</h2>
                <p>Get started in 2 minutes</p>
              </div>

              <form onSubmit={this.handleSubmit}>
                <div className="template9-input-group">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={this.handleChange}
                    placeholder="Your Name *"
                    className={errors.name ? 'error' : ''}
                  />
                  {errors.name && <span className="template9-error">{errors.name}</span>}
                </div>

                <div className="template9-input-group">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={this.handleChange}
                    placeholder="Phone Number *"
                    maxLength="10"
                    className={errors.phone ? 'error' : ''}
                  />
                  {errors.phone && <span className="template9-error">{errors.phone}</span>}
                </div>

                <div className="template9-input-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={this.handleChange}
                    placeholder="Email (optional)"
                    className={errors.email ? 'error' : ''}
                  />
                  {errors.email && <span className="template9-error">{errors.email}</span>}
                </div>

                <div className="template9-row">
                  <div className="template9-input-group">
                    <select
                      name="area"
                      value={formData.area}
                      onChange={this.handleChange}
                    >
                      <option value="">Select Area</option>
                      {areas.map((area, index) => (
                        <option key={index} value={area}>{area}</option>
                      ))}
                    </select>
                  </div>

                  <div className="template9-input-group">
                    <select
                      name="course"
                      value={formData.course}
                      onChange={this.handleChange}
                      className={errors.course ? 'error' : ''}
                    >
                      <option value="">Select Course *</option>
                      {courses.map((course, index) => (
                        <option key={index} value={course}>{course}</option>
                      ))}
                    </select>
                    {errors.course && <span className="template9-error">{errors.course}</span>}
                  </div>
                </div>

                <div className="template9-input-group">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={this.handleChange}
                    placeholder="Any specific queries? (optional)"
                    rows="2"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="template9-submit"
                  disabled={disabled || loader}
                >
                  {loader ? (
                    <>
                      <i className="fa fa-spinner fa-spin"></i> Submitting...
                    </>
                  ) : (
                    <>
                      Submit Enquiry <i className="fa fa-arrow-right"></i>
                    </>
                  )}
                </button>

                <p className="template9-privacy">
                  <i className="fa fa-lock"></i> Your information is safe with us
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const ConnectedEnquiryTemplate9 = connect(mapStateToProps)(EnquiryTemplate9);
export default ConnectedEnquiryTemplate9;
